import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Point } from "appworks/utils/geom/point";
import { SlingoInitRecordBuilder } from "slingo/integration/builders/records/slingo-init-record-builder";
import { SlingoRecord } from "slingo/model/records/slingo-record";
import { slotDefinition } from "slotworks/model/slot-definition";

export class FowlInitRecordBuilder extends SlingoInitRecordBuilder {
    public build(gameplay: Gameplay, request: any, response: any): SlingoRecord[] {
        const configs = response.data.config;
        const slotConfigs = configs.feature.slotsConfig;

        /** Parse Slot Bonus Config */
        // Reelstrips
        for (let i = 1; i <= 3; i++) {
            slotDefinition.reelsets.set(
                "slotbonus_" + this.getLadderLevelForSlotBonusType(i),
                slotConfigs["slots-fowlplay-fs" + i].standardSpinReelSets[0].reels.map(obj => obj.symbols.map(num => slotDefinition.symbolDefinitions[num].id))
            );
        }

        // Lines
        slotDefinition.lines.values = slotConfigs["slots-fowlplay-fs1"].paylines.map((line: string) => line.split("").map((y, x) => new Point(x, parseInt(y))));

        return super.build(gameplay, request, response);
    }

    protected getLadderLevelForSlotBonusType(bonusType: number): number {
        // Gonna store the reelset with their respective ladder level rather than just 1/2/3, saves doing this logic elsewhere
        switch (bonusType) {
            case 1:
                return 6;
            case 2:
                return 8;
            case 3:
                return 10;
        }
    }
}
